<template>
    <b-modal size="lg" id="edit_modal" ref="modal" title="Edit Media" :busy="loading">
        <b-overlay variant="card" :show="loading">
            <b-alert variant="danger" :show="error != null">{{ error }}</b-alert>
            <b-form class="form" @submit.prevent="doEdit">
                <b-tabs content-class="mt-3 text-info">
                    <media-form-basic-info :form="$v.form"></media-form-basic-info>
                    <!-- <media-form-playlists :form="$v.form" :playlists="playlists"></media-form-playlists> -->
                    <media-form-album-art :album-art-url="albumArtUrl" :album-art-src="form.art"></media-form-album-art>
                    <!-- <media-form-custom-fields v-if="customFields.length > 0" :form="$v.form" :custom-fields="customFields"></media-form-custom-fields> -->
                    <!-- <media-form-waveform-editor :form="form" :audio-url="audioUrl" :waveform-url="waveformUrl"></media-form-waveform-editor> -->
                    <!-- <media-form-advanced-settings :form="$v.form" :song-length="songLength"></media-form-advanced-settings> -->
                </b-tabs>
                <invisible-submit-button/>
            </b-form>
        </b-overlay>
        <template v-slot:modal-footer>
            <b-button variant="default" @click="close">
                <span key="lang_btn_close">Close</span>
            </b-button>
            <b-button variant="info" @click="doEdit" :disabled="$v.form.$invalid">
                <span key="lang_btn_save">Save Changes</span>
            </b-button>
        </template>
    </b-modal>
</template>
<script>
import { validationMixin } from 'vuelidate';
import required from 'vuelidate/src/validators/required';
import _ from 'lodash';
import MediaFormBasicInfo from './Form/BasicInfo';
import MediaFormAlbumArt from './Form/AlbumArt';
// import MediaFormCustomFields from './Form/CustomFields';
// import MediaFormAdvancedSettings from './Form/AdvancedSettings';
// import MediaFormPlaylists from './Form/Playlists';
import InvisibleSubmitButton from '@/components/common/InvisibleSubmitButton';
// import MediaFormWaveformEditor from './Form/WaveformEditor';
import { DISPATCH_UPDATE } from "@/store/action-types";
export default {
    name: 'MediaModal',
    components: {
        // MediaFormPlaylists,
        // MediaFormWaveformEditor,
        // MediaFormAdvancedSettings,
        // MediaFormCustomFields,
        MediaFormAlbumArt,
        MediaFormBasicInfo,
        InvisibleSubmitButton
    },
    mixins: [validationMixin],
    props: {
        customFields: Array,
        playlists: Array
    },
    data () {
        return {
            loading: true,
            recordUrl: null,
            error: null,
            albumArtUrl: null,
            waveformUrl: null,
            audioUrl: null,
            songLength: null,
            form: this.getBlankForm()
        };
    },
    validations () {
        let validations = {
            form: {
                path: {
                    required
                },
                title: {},
                title: {},
                artist: {},
                album: {},
                genre: {},
                lyrics: {},
                isrc: {},
                art: {},
                amplify: {},
                fade_overlap: {},
                fade_in: {},
                fade_out: {},
                cue_in: {},
                cue_out: {},
                playlists: {},
                custom_fields: {}
            }
        };

        // _.forEach(this.customFields.slice(), (field) => {
        //     validations.form.custom_fields[field.short_name] = {};
        // });

        return validations;
    },
 
    methods: {
        getBlankForm () {
            // let customFields = {};
            // _.forEach(this.customFields.slice(), (field) => {
            //     customFields[field.short_name] = null;
            // });

            return {
                art: null,
                path: null,
                title: null,
                artist: null,
                album: null,
                genre: null,
                lyrics: null,
                isrc: null,
                amplify: null,
                fade_overlap: null,
                fade_in: null,
                fade_out: null,
                cue_in: null,
                cue_out: null,
                playlists: [],
                // custom_fields: customFields
            };
        },
        open (file) {

            this.loading = false;
            this.error = null;
            this.albumArtUrl = `admin/files/art/${file.id}`;
            // this.waveformUrl = waveformUrl;
            // this.recordUrl =  recordUrl;

            this.audioUrl = `admin/files/${file.id}`;
    
                this.songLength = file.length_text;
                this.form = {
                    art: file.art,
                    path: file.path,
                    title: file.title,
                    artist: file.artist,
                    album: file.album,
                    genre: file.genre,
                    lyrics: file.lyrics,
                    amplify: file.amplify,
                    fade_overlap: file.fade_overlap,
                    fade_in: file.fade_in,
                    fade_out: file.fade_out,
                    cue_in: file.cue_in,
                    cue_out: file.cue_out,
                    isrc: file.isrc,
                    playlists: _.map(file.playlists, 'id'),
                    // custom_fields: {}
                };

                this.$refs.modal.show();


        },
        close () {
            this.loading = false;
            this.error = null;
            this.albumArtUrl = null;
            this.audioUrl = null;

            this.form = this.getBlankForm();

            this.$v.form.$reset();
            this.$refs.modal.hide();
        },
        doEdit () {
            this.$v.form.$touch();
            if (this.$v.form.$anyError) {
                return;
            }

            this.error = null;

            this.$store.dispatch(DISPATCH_UPDATE, {data:this.form, url:this.audioUrl})
            .then(() => {
                this.$emit('relist');
                this.close();
            }).catch(() => {
                
            });
        }
    }
};
</script>
